import { Button, Modal } from "materia"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import s from "./RenameGroup.module.scss"

type RenameGroupProps = {
  name: string
  onRename: (name: string) => void
  onClose: () => void
}

export function RenameGroup({ name, onRename, onClose }: RenameGroupProps) {
  const { t } = useTranslation()
  const [draft, setDraft] = useState(name)

  const trimmed = draft.trim()
  const canSave = trimmed.length > 0 && trimmed !== name

  return (
    <Modal ariaLabel={String(t("chat.RENAME_GROUP"))} onClose={onClose}>
      <form
        className={s.rename}
        onSubmit={(event) => {
          event.preventDefault()
          if (canSave) onRename(trimmed)
        }}
      >
        <h2 className={s.rename__title}>{t("chat.RENAME_GROUP")}</h2>

        <input
          className={s.rename__input}
          value={draft}
          aria-label={String(t("chat.GROUP_NAME_LABEL"))}
          placeholder={String(t("chat.GROUP_NAME_LABEL"))}
          // biome-ignore lint/a11y/noAutofocus: the dialog exists to edit this one field
          autoFocus
          onChange={(event) => setDraft(event.target.value)}
        />

        <div className={s.rename__actions}>
          <Button theme="cancel" borderRadius="24" onClick={onClose}>
            {t("actions.CANCEL")}
          </Button>
          <Button
            theme="blue"
            borderRadius="24"
            type="submit"
            disabled={!canSave}
          >
            {t("chat.SAVE")}
          </Button>
        </div>
      </form>
    </Modal>
  )
}
